//on ready
document.addEventListener("DOMContentLoaded", function() {

    //call loadin
    // $body.rhLoadIn();

    // jQuery('#ajaxContainer').rhLoadIn({
    //     ajax:true
    // });


    // jQuery(".parallax").rhParallax({
    //     parallaxRatio: 1.4
    // });


}); // end doc ready